import { setup } from '../../entry';

import App from './App.vue';

setup(App);
